import { render, staticRenderFns } from "./Briefverwerking.vue?vue&type=template&id=879bbba8&scoped=true&"
import script from "./Briefverwerking.vue?vue&type=script&lang=js&"
export * from "./Briefverwerking.vue?vue&type=script&lang=js&"
import style0 from "./Briefverwerking.vue?vue&type=style&index=0&id=879bbba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879bbba8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VWindow } from 'vuetify/lib/components/VWindow';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VBtn,VForm,VIcon,VWindow,VWindowItem})
